import { Module } from 'vuex';
import Product from '@/classes/Product';
import AppDate from '@/classes/AppDate';

const productsModule: Module<any, any> = {
  namespaced: true,

  state: {
    products: {} as Record<string, Product[]>,
    fetchedAt: {} as Record<string, AppDate>,
  },

  mutations: {
    SET_PRODUCTS(state, payload: {
      branch: string
      products: Product[]
    }) {
      state.products[payload.branch] = payload.products;
      state.fetchedAt[payload.branch] = new AppDate();
    },
  },

  getters: {
    get: (state) => (branch: string): Product[] => {
      const dateNow = new AppDate();

      const dateBranch = state.fetchedAt[branch];
      const productsBranch = state.products[branch];

      if (productsBranch && dateBranch && dateNow.diffInMinutes(dateBranch) < 30) {
        return productsBranch || [];
      }

      return [];
    },
  },
};

export default productsModule;
